import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import DatePicker from 'react-datepicker2';
import SelectAsync from 'react-select/async';

export default class Close extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            record: {
                annualId: null,
                newAnnualTitle: '',
                newAnnualFrom: null,
                newAnnualTo: null,
                closeDate: null,
                incomeTaxPercent: 0,
                incomeTaxPrice: 0,
                sodoZiyanMoeinCode: 0,
                annualCloseMoein: 0,
                annualStartMoein: 0,
                sodoZiyanAnbashteMoeinCode: 0,
                zakhireMaliyatMoeinCode: 0
            }
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/annual/getclose")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {

                    window.organizationId = data.global.company.id;
                    this.state.record.newAnnualFrom = data.newAnnualFrom;
                    this.state.record.newAnnualTo = data.newAnnualTo;
                    this.state.record.closeDate = data.to;
                    this.state.record.annualId = data.id;
                    
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save() {

        this.httpPost("api/v1/annual/saveclose", {
            annualId: this.state.data.annual.id,
            organizationId: this.state.data.global.company.id,            
            newAnnualTitle: this.state.record.newAnnualTitle,
            newAnnualFrom: this.convertMomentToDb(this.state.record.newAnnualFrom),
            newAnnualTo: this.convertMomentToDb(this.state.record.newAnnualTo),
            closeDate: this.convertMomentToDb(this.state.record.closeDate),
            incomeTaxPercent: this.state.record.incomeTaxPercent,
            incomeTaxPrice: this.state.record.incomeTaxPrice,
            sodoZiyanMoeinCode: this.state.record.sodoZiyanMoeinCode,
            annualCloseMoein: this.state.record.annualCloseMoein,
            annualStartMoein: this.state.record.annualStartMoein,
            sodoZiyanAnbashteMoeinCode: this.state.record.sodoZiyanAnbashteMoeinCode,
            zakhireMaliyatMoeinCode: this.state.record.zakhireMaliyatMoeinCode,
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("سال مالی با موفقیت بسته و سال مالی جدید ایجاد شد");
                this.setState({ redirect: "/" });
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    renderForm() {
        return <div method="post">
            <div className="container">
                <div className="row center-block">
                    {this.state.data.annual.warehouseHandling ?
                        <p className="acc-page-top-help-box" style={{ "background-color": "#f6e7ed", "border": "1px solid #b22a3d" }} >
                            <span className="fa fa-warning-circle fa-2x" style={{ "color": "#b22a3d" }} ></span>&nbsp;&nbsp;
                            <span>سند اختتامیه برای سال مالی انتخاب شده قبلا صادر شده و امکان ثبت مجدد سند وجود ندارد.</span>
                        </p>
                        :
                        <div>
                            <p className="acc-page-top-help-box">
                                <span className="fa fa-info-circle fa-2x" style={{ "color": "#2ab27b" }} ></span>&nbsp;&nbsp;
                                <span>توجه": "قبل از بستن دوره مالی، ترازنامه و مانده حسابهای خود را بررسی کنید و در صورت نیاز ثبت های اصلاحی را انجام دهید.</span>
                            </p>
                            <div className="row">
                                <div className="col-sm-4">
                                    <label>نام دوره مالی جاری:</label> {this.state.data.annual.title}
                                </div>
                                <div className="col-sm-4">
                                    <label>تاریخ شروع:</label> {this.state.data.annual.fromPersian}
                                </div>
                                <div className="col-sm-4">
                                    <label>تاریخ پایان:</label> {this.state.data.annual.toPersian}
                                </div>
                            </div>
                            <div className="row" style={{"margin-top": "10px"}}>
                                <div className="col-sm-2">
                                    <label>نام دوره مالی جدید:</label>
                                </div>
                                <div className="col-sm-2">
                                    <input defaultValue={this.state.record.newAnnualTitle} onChange={e => this.state.record.newAnnualTitle = e.target.value} autocomplete="off" type="text" className="form-control input-sm ng-valid" />
                                </div>
                                <div className="col-sm-2">
                                    <label>تاریخ شروع:</label>
                                </div>
                                <div className="col-sm-2">
                                    <DatePicker
                                        inputReadOnly={true}
                                        className="form-control input-sm persian-date"
                                        placeholder={"انتخاب تاریخ"}
                                        isGregorian={false}
                                        showTodayButton={true}
                                        timePicker={false}
                                        onChange={(e) => { this.state.record.newAnnualFrom = e }}
                                        value={this.getFormatedDateForDatePicker(this.state.record.newAnnualFrom)}
                                    />
                                </div>
                                <div className="col-sm-2">
                                    <label>تاریخ پایان:</label>
                                </div>
                                <div className="col-sm-2">
                                    <DatePicker
                                        inputReadOnly={true}
                                        className="form-control input-sm persian-date"
                                        placeholder={"انتخاب تاریخ"}
                                        isGregorian={false}
                                        showTodayButton={true}
                                        timePicker={false}
                                        onChange={(e) => { this.state.record.newAnnualTo = e }}
                                        value={this.getFormatedDateForDatePicker(this.state.record.newAnnualTo)}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ "margin-top": "10px" }}>
                                <div className="col-sm-2">
                                    <label>تاریخ بستن سال مالی:</label>
                                </div>
                                <div className="col-sm-2">
                                    <DatePicker
                                        inputReadOnly={true}
                                        className="form-control input-sm persian-date"
                                        placeholder={"انتخاب تاریخ"}
                                        isGregorian={false}
                                        showTodayButton={true}
                                        timePicker={false}
                                        onChange={(e) => { this.state.record.closeDate = e }}
                                        value={this.getFormatedDateForDatePicker(this.state.record.closeDate)}
                                    />
                                </div>
                                <div className="col-sm-2">
                                    <label>معین اختتامیه:</label>
                                </div>
                                <div className="col-sm-2">
                                    <SelectAsync
                                        style={{ "width": "100%" }}
                                        defaultValue={null}
                                        isMulti={false}
                                        placeholder="انتخاب معین"
                                        defaultOptions
                                        loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
                                        onChange={e => this.state.record.annualCloseMoein = e.value}
                                    />
                                </div>
                                <div className="col-sm-2">
                                    <label>معین افتتاحیه:</label>
                                </div>
                                <div className="col-sm-2">
                                    <SelectAsync
                                        style={{ "width": "100%" }}
                                        defaultValue={null}
                                        isMulti={false}
                                        placeholder="انتخاب معین"
                                        defaultOptions
                                        loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
                                        onChange={e => this.state.record.annualStartMoein = e.value}
                                    />
                                </div>
                            </div>

                            <div className="row" style={{ "margin-top": "10px" }}>
                                <div className="col-sm-2">
                                    <label>معین سود و زیان:</label>
                                </div>
                                <div className="col-sm-2">
                                    <SelectAsync
                                        style={{ "width": "100%" }}
                                        defaultValue={null}
                                        isMulti={false}
                                        placeholder="انتخاب معین"
                                        defaultOptions
                                        loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
                                        onChange={e => this.state.record.sodoZiyanMoeinCode = e.value}
                                    />
                                </div>
                                <div className="col-sm-2">
                                    <label>معین سود و زیان انباشته:</label>
                                </div>
                                <div className="col-sm-2">
                                    <SelectAsync
                                        style={{ "width": "100%" }}
                                        defaultValue={null}
                                        isMulti={false}
                                        placeholder="انتخاب معین"
                                        defaultOptions
                                        loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
                                        onChange={e => this.state.record.sodoZiyanAnbashteMoeinCode = e.value}
                                    />
                                </div>
                                <div className="col-sm-2">
                                    <label>معین ذخیره مالیات عملکرد:</label>
                                </div>
                                <div className="col-sm-2">
                                    <SelectAsync
                                        style={{ "width": "100%" }}
                                        defaultValue={null}
                                        isMulti={false}
                                        placeholder="انتخاب معین"
                                        defaultOptions
                                        loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
                                        onChange={e => this.state.record.zakhireMaliyatMoeinCode = e.value}
                                    />
                                </div>
                            </div>

                            <div className="bs-callout bs-callout-success">
                                <h4>
                                    <span className={this.state.data.profit < 0 ? "ng-hide" : ""}>سود خالص: </span>
                                    <span className={this.state.data.profit < 0 ? "" : "ng-hide"}>زیان خالص: </span>
                                    <span className="txt-dark"> {this.money(Math.abs(this.state.data.profit))}</span>
                                    <span className={this.state.data.profit < 0 ? "red" : "green"}> {this.state.data.global.company.currencyUnit}</span>
                                </h4>
                            </div>

                            <div className="bs-callout bs-callout-danger">
                                <h4>مالیات بر درآمد</h4>
                                <p>اگر شما مالیات بر درآمد می پردازید در اینجا میزان مالیات بر درآمد خود را مشخص کنید.</p>
                                <div className="row">
                                    <div className="col-sm-4 form-inline ng-hide">
                                        <div className="form-group">
                                            <label>درصد مالیات بر درآمد:</label>
                                            <div className="input-group">
                                                <input defaultValue={this.state.record.incomeTaxPercent} onChange={e => this.state.record.incomeTaxPercent = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm ng-valid" style={{ "width": "100px" }} />
                                                <span className="input-group-addon">%</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-8 form-inline">
                                        <div className="form-group">
                                            <label>مبلغ مالیات بر درآمد:</label>
                                            <div className="input-group">
                                                <input defaultValue={this.state.record.incomeTaxPrice} onChange={e => this.state.record.incomeTaxPrice = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm ng-valid" style={{ "width": "180px" }} />
                                                <span className="input-group-addon">{this.state.data.global.company.currencyUnit}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bs-callout bs-callout-primary ng-hide">
                                <h4>
                                    <span className="ng-hide">سود</span>
                                    <span className="">زیان</span>
                                    ویژه (
                                    <span className="ng-hide">سود</span>
                                    <span className="">زیان</span>
                                    خالص پس از کسر مالیات):
                                    <span className="txt-dark ng-hide"> {this.state.data.global.company.currencyUnit}</span>
                                    <span className="red"> {this.state.data.global.company.currencyUnit}</span>
                                </h4>
                            </div>

                            <div className="bs-callout bs-callout-info ng-hide">
                                <h4>تقسیم
                                    <span className="ng-hide">سود</span>
                                    <span className="">زیان</span>
                                </h4>
                                <p>
                                    اگر
                                    <span className="ng-hide">سود</span>
                                    <span className="">زیان</span>
                                    دوره مالی را بین سهامداران تقسیم میکنید در اینجا مقدار آن را مشخص کنید.
                                    <br />
                                    <span className="ng-hide">سود</span>
                                    <span className="">زیان</span>
                                    ویژه شما ، مبلغ ۱۰,۵۰۰- {this.state.data.global.company.currencyUnit} می باشد.
                                    چند درصد از این
                                    <span className="ng-hide">سود</span>
                                    <span className="">زیان</span>
                                    را بین سهامداران تقسیم و چند درصد از آن را بعنوان
                                    <span className="ng-hide">سود</span>
                                    <span className="">زیان</span>
                                    انباشته به دوره
                                    مالی بعد منتقل میکنید.
                                </p>
                                <div className="row">
                                    <div className="col-xs-2">
                                        <div className="input-group">
                                            <input autocomplete="off" type="text" className="form-control input-sm ng-valid" />
                                            <span className="input-group-addon" id="basic-addon2">%</span>
                                        </div>
                                    </div>
                                    <div className="col-xs-6">
                                        از
                                        <span className="ng-hide">سود</span>
                                        <span className="">زیان</span>
                                        بین سهامداران تقسیم میشود.
                                    </div>
                                    <div className="col-xs-4 form-inline">
                                        <div className="input-group">
                                            <input autocomplete="off" type="text" className="form-control input-sm ng-valid"
                                                onkeypress="return isNumberKey(event)" style={{ "width": "180px" }} />
                                            <span className="input-group-addon">{this.state.data.global.company.currencyUnit}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row m-t-5">
                                    <div className="col-xs-2">
                                        <div className="input-group">
                                            <input autocomplete="off" type="text" className="form-control input-sm ng-valid" disabled="disabled" />
                                            <span className="input-group-addon" id="basic-addon3">%</span>
                                        </div>
                                    </div>
                                    <div className="col-xs-6">
                                        از
                                        <span className="ng-hide">سود</span>
                                        <span className="">زیان</span>
                                        بعنوان
                                        <span className="ng-hide">سود</span>
                                        <span className="">زیان</span>
                                        انباشته به دوره مالی بعد منتقل میشود.
                                    </div>
                                    <div className="col-xs-4">مبلغ": "۰ {this.state.data.global.company.currencyUnit}</div>
                                </div>
                                <h4 style={{"margin-top": "15px", "margin-bottom": "15px" }}>لسیت سهامداران</h4>
                                <table className="table table-bordered table-striped table-hover" id="grid">
                                    <thead>
                                        <tr className="active" style={{ "font-size": "9pt", "font-weight": "bold" }}>
                                            <td>ردیف</td>
                                            <td>نام سهامدار</td>
                                            <td>درصد سهم</td>
                                            <td>مبلغ
                                                <span className="ng-hide">سود</span>
                                                <span className="">زیان</span>
                                                سهامدار ({this.state.data.global.company.currencyUnit})</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data.stockHolders.map((s, index) =>
                                            <tr>
                                                <td className="text-center">{index++}</td>
                                                <td className="text-primary"><strong>{s.name}</strong></td>
                                                <td className="text-center">{s.percent}</td>
                                                <td></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table >
                            </div >

                            <div className="row text-center">
                                <a onClick={e => this.save()} autocomplete="off" className="btn btn-primary">بستن دوره مالی و ایجاد دوره مالی جدید</a>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.renderForm(),
                <Footer />
            ];

        return contents;
    }
}